import { useSelector } from "react-redux";
import { Card, Col, Progress, Row } from "antd";
import { UNITS } from "../../../../../Common/Constants";
import { EOL_TESTS } from "../../../../../Common/Grafana/Constants";
import GetIframe from "../../../../../Common/Grafana/GetIframe";
import { getGrafanaBaseURL } from "../../../../../Common/Utils";
import { useMemo } from "react";

const ModeGrafana = ({ item, rearTyreDiameter }) => {
  const eol = useSelector((state) => state.eolTests);
  const vehicleSlice = useSelector((state) => state.eol);
  const vehicleDetails = vehicleSlice?.vehicleDetails;
  const response =
    Object.keys(eol?.dynoStopDetails).length !== 0
      ? eol?.dynoStopDetails
      : eol?.dynoResult;

  const renderResult = (status) => {
    if (status === true) {
      return (
        <Progress
          type="circle"
          size={22}
          percent={100}
          strokeColor={{
            "0%": "#108ee9",
            "100%": "#87d068",
          }}
        />
      );
    } else if (status === false) {
      return (
        <Progress type="circle" size={22} percent={100} status="exception" />
      );
    } else {
      return "";
    }
  };

  const baseFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicleDetails?.id,
      drive_mode: item.mode,
      rear_wheel_diameter: rearTyreDiameter,
      from: response.startTime,
      to: response.stopTime,
    };
  }, [
    vehicleDetails?.id,
    item.mode,
    rearTyreDiameter,
    response.startTime,
    response.stopTime,
  ]);

  const modeBasedFields = () => {
    return {
      speed:
        response?.data?.dynoTestResults?.[item.mode]?.modeData?.speed ||
        response?.data?.dynoTestResults?.[item.mode]?.modeData?.speed === 0
          ? response?.data?.dynoTestResults?.[item.mode]?.modeData?.speed
          : null,
      result: renderResult(
        response?.data?.dynoTestResults?.[item.mode]?.modeData?.dyno_result
      ),
      timeSeriesPanel:
        EOL_TESTS.DYNO.PANEL_ID["history"][
          item.mode === "REVERSE" ? "reverse" : "mode"
        ]["timeSeries"],
      histogramPanel:
        EOL_TESTS.DYNO.PANEL_ID["history"][
          item.mode === "REVERSE" ? "reverse" : "mode"
        ]["histogram"],
      boxPlotPanel:
        EOL_TESTS.DYNO.PANEL_ID["history"][
          item.mode === "REVERSE" ? "reverse" : "mode"
        ]["boxPlot"],
    };
  };

  const ModeCard = () => {
    return (
      <Card title={item?.mode} className="mt075">
        <Row gutter={[16, 16]} className="pdtb1">
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            Target: <b>{item.max}</b> {UNITS.KM_PER_HR}
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            Speed:{" "}
            {modeBasedFields()?.speed ? (
              <>
                {" "}
                <b>{parseFloat(modeBasedFields()?.speed)}</b> {UNITS.KM_PER_HR}{" "}
              </>
            ) : (
              <span className="disabled">NA</span>
            )}
          </Col>
          <Col className="flex-center" xs={24} sm={24} md={24} lg={8} xl={8}>
            Result:{" "}
            {modeBasedFields()?.result ? (
              <span className="ml05">{modeBasedFields()?.result}</span>
            ) : (
              <span className="disabled ml025">NA</span>
            )}
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={10}
            xl={10}
            id={`${item?.mode.toLowerCase()}-time-series`}
          >
            <GetIframe
              title="Time Series"
              url={getGrafanaBaseURL(
                EOL_TESTS.DYNO.DASHBOARD_ID,
                EOL_TESTS.DYNO.DASHBOARD_NAME
              )}
              panelId={modeBasedFields()?.timeSeriesPanel}
              variableObject={baseFilterObject}
              variableKeys={EOL_TESTS.DYNO.MODE_VARIABLES}
              width="100%"
              height="270"
              divId={`${item?.mode.toLowerCase()}-time-series`}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={7}
            xl={7}
            id={`${item?.mode.toLowerCase()}-histogram`}
          >
            <GetIframe
              title="Histogram"
              url={getGrafanaBaseURL(
                EOL_TESTS.DYNO.DASHBOARD_ID,
                EOL_TESTS.DYNO.DASHBOARD_NAME
              )}
              panelId={modeBasedFields()?.histogramPanel}
              variableObject={baseFilterObject}
              variableKeys={EOL_TESTS.DYNO.MODE_VARIABLES}
              width="100%"
              height="270"
              divId={`${item?.mode.toLowerCase()}-histogram`}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={7}
            xl={7}
            id={`${item?.mode.toLowerCase()}-boxplot`}
          >
            <GetIframe
              title="Boxplot"
              url={getGrafanaBaseURL(
                EOL_TESTS.DYNO.DASHBOARD_ID,
                EOL_TESTS.DYNO.DASHBOARD_NAME
              )}
              panelId={modeBasedFields()?.boxPlotPanel}
              variableObject={baseFilterObject}
              variableKeys={EOL_TESTS.DYNO.MODE_VARIABLES}
              width="100%"
              height="270"
              divId={`${item?.mode.toLowerCase()}-boxplot`}
            />
          </Col>
        </Row>
      </Card>
    );
  };

  return <ModeCard />;
};

export default ModeGrafana;
